<template>
    <div class="rollrattigheter">
        <div class="header">
            <admin-lock-border />
            <h2>Rollrättigheter</h2>
        </div>
        <table>
            <thead>
                <tr>
                    <th>
                        <Button @click="loadFromApi">Ladda</Button>
                    </th>
                    <th v-for="roll in roller" :key="roll.id">
                        <div>
                            <span>
                                {{ roll.displayName }}
                            </span>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="permission in permissions" :key="permission.id">
                    <th>
                        <div>
                            <span>
                                {{ permission.name }}
                            </span>
                        </div>
                    </th>
                    <td v-for="roll in roller" :key="roll.id">
                        <span v-if="roll.permissions.includes(permission.id)">X</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import tabIcon from "@/assets/gear.svg";

    export default {
        name: "Rollrattigheter",
        tabName: "Rollrättigheter",
        icon: tabIcon,
    };
</script>

<script setup>
    import { ref, useAttrs, toRefs, onMounted } from "vue";
    import { getConfig, klinikenApi } from "@/api";
    import AdminLockBorder from "@/components/AdminLockBorder.vue";
    import Button from "@/components/Button.vue";

    const props = defineProps({
        parameters: Object,
    });

    const roller = ref([]);
    const permissions = ref([]);

    async function loadFromApi() {
        const rollerResponse = await klinikenApi.get("/core/kodverk/roller/", getConfig());
        roller.value = rollerResponse.data.results;

        const permissionsResponse = await klinikenApi.get("/core/permissions/", getConfig());
        permissions.value = permissionsResponse.data;
    }

    onMounted(() => {
        loadFromApi();
    });
</script>

<style lang="scss">
    .rollrattigheter {
        table {
            border: none;
            border-collapse: separate;
            border-spacing: 0;
            table-layout: fixed;
            white-space: nowrap;
        }

        thead {
            th {
                z-index: 2;
                background-color: white;
                position: sticky;
                top: -46px; /* TODO: Om marginalerna på tabcontainern ändras måste den här justeras på samma sätt */
                height: 220px;
                border-right: #1a202c 1px solid;

                div {
                    transform: translate(0px, 100px) rotate(-90deg);
                    width: 30px;

                    span {
                        padding: 5px 10px;
                    }
                }
            }
        }

        tbody {
            th,
            td {
                border-right: #1a202c 1px solid;
            }

            th {
                z-index: 1;
                position: sticky;
                left: -46px; /* TODO: Om marginalerna på tabcontainern ändras måste den här justeras på samma sätt */
            }

            td {
                text-align: center;
            }

            tr:nth-child(even) {
                th,
                td {
                    background-color: #f2f2f2; /* Light gray for even rows */
                }
            }

            tr:nth-child(odd) {
                th,
                td {
                    background-color: #fff; /* White for odd rows */
                }
            }
        }
    }
</style>
